import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, COUPON_REPORT_LIST } from "../../../../Constants/Config";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
const initialState = {
  loading: false,
  CouponReportData: [],
  status: false,
  successMessage: "",
  error: "",
};
let cancelTokenSource;
// Generate pening , fulfilled and rejected action type
export const fetchCouponReportData = createAsyncThunk(
  "CouponReportList/fetchCouponReportData.",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + COUPON_REPORT_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      console.log(response);
      if (response.data.coupon_report_data.length > 0) {
        // console.log(response.data
        //     )
        const arr = response.data.coupon_report_data;
        const status = response.data.status;
        return { arr, status };
      } else if (response.data.coupon_report_data.length === 0) {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
const CouponReportSlice = createSlice({
  name: "CouponReportList",
  initialState,
  reducers: {
    updateStateOfCoupon: (state) => {
      state.CouponReportData = [];
    },
    updateStatusCouponReportData: (state) => {
      state.status = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCouponReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCouponReportData.fulfilled, (state, action) => {
      state.loading = false;
      state.CouponReportData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchCouponReportData.rejected, (state, action) => {
      state.loading = false;
      state.CouponReportData = {};
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfCoupon, updateStatusCouponReportData } =
  CouponReportSlice.actions;
export default CouponReportSlice.reducer;
